<!--
 * @Description:
 * @Author: mdb
 * @Date: 2023-04-13 13:53:26
 * @LastEditTime: 2023-04-19 18:10:24
 * @LastEditors: mdb
-->
<template>
  <TagsManage subdomain="fbu" :permission="permission" />
</template>

<script setup lang="ts">
import TagsManage from '@/views/marketing/marketingManage/tagsManage/index.vue'

const permission = {
  add: 'fbu_tags_add_btn',
  edit: 'fbu_tags_edit_btn',
  del: 'fbu_tags_del_btn',
  enable: 'fbu_tags_enable_btn',
  disable: 'fbu_tags_disable_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuTagManage' }
</script>

<style scoped></style>
